import BaseApi from "./BaseApi";

export default class Department extends BaseApi{
    construct() {}

    static async search(params) {
        return await Department.getAxiosInstance().get(Department.getApiUrl(),{params: params});
    }

    static async create(params) {
        return await Department.getAxiosInstance().post(Department.getApiUrl(),params);
    }

    static async update(params, id) {
        return await Department.getAxiosInstance().put(Department.getApiUrl() + id,params);
    }

    static async delete(id) {
        return await Department.getAxiosInstance().delete(Department.getApiUrl() + id);
    }

    static async find(id) {
        return await Department.getAxiosInstance().get(Department.getApiUrl() + id);
    }

    static async list(params) {
        let url = Department.getApiUrl() + "list";

        return Department.getAxiosInstance().get(url,{params: params});
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/departments/";
    }
}